import { createRequire } from 'node:module';
import { pathToFileURL } from 'node:url';
import { findUpAndReadPackageJson } from '@shopify/cli-kit/node/node-package-manager';
import { joinPath, dirname } from '@shopify/cli-kit/node/path';

const require2 = createRequire(import.meta.url);
async function importVite(root) {
  const vitePath = require2.resolve(
    "vite",
    process.env.SHOPIFY_UNIT_TEST ? void 0 : { paths: [root] }
  );
  const vitePackageJson = await findUpAndReadPackageJson(vitePath);
  let viteNodeIndexFile = vitePackageJson.content.exports?.["."];
  if (typeof viteNodeIndexFile !== "string") {
    viteNodeIndexFile = viteNodeIndexFile?.import;
  }
  if (typeof viteNodeIndexFile !== "string") {
    viteNodeIndexFile = viteNodeIndexFile.default;
  }
  const viteNodePath = joinPath(
    dirname(vitePackageJson.path),
    viteNodeIndexFile
  );
  return import(pathToFileURL(viteNodePath).href);
}
function importLocal(packageName, path) {
  const realPath = require2.resolve(
    packageName,
    process.env.SHOPIFY_UNIT_TEST ? void 0 : { paths: [path] }
  );
  return import(pathToFileURL(realPath).href);
}

export { importLocal, importVite };
